import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const ServicePointDefault: FC<SvgIconProps> = ({ viewBox = '0 0 254 179', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path
      d="m100.555 31.837-2.242 3.243s-9.612 3.696-12.284 9.176c0 0-3.07 3.826 0 37.677l48.797 1.33-3.562-39.137s-1.167-10.44-7.555-11.867l-11.178-1.946-11.976 1.524Z"
      fill="#E5E5E5"
    />
    <path d="m109.092 39.133.768 9.338 1.934-.39-.767-9.435-1.935.487Z" fill="#C9C9C9" />
    <path d="M100.524 28.206v3.534l9.336 7.263 3.132-8.56-12.468-2.237Z" fill="#DEA07B" />
    <path
      d="m85.477 75.967 5.066-1.07a25.734 25.734 0 0 1-1.474-7.393c0-2.886-.49-8.17-.49-8.17a56.11 56.11 0 0 1 2.057-12.711c1.597-3.988 10.594-8.95 10.594-8.95l-3.07-2.593a41.26 41.26 0 0 0-8.353 4.701 9.712 9.712 0 0 0-3.41 3.48 10.393 10.393 0 0 0-1.381 4.788c-.665 9.301-.51 18.647.46 27.918Z"
      fill="#C9C9C9"
    />
    <path
      d="m100.524 31.74 9.336 7.263-2.457 3.89-9.12-7.976 2.241-3.177ZM95.703 52.232l.123 21.757 2.241-.39"
      fill="#8E8E8E"
    />
    <path
      d="m114.896 30.767 8.322 1.33a9.035 9.035 0 0 1 3.637 1.91 9.676 9.676 0 0 1 2.505 3.375 31.89 31.89 0 0 1 2.457 12.97l-1.045.454s-1.412-11.803-5.681-14.04a58.944 58.944 0 0 0-10.533-3.243l.338-2.756Z"
      fill="#F4F4F4"
    />
    <path
      d="m122.634 45.228 4.085 22.925-1.812.356M112.992 30.443l-3.132 8.56 3.5 1.978 1.536-10.214-1.904-.324Z"
      fill="#8E8E8E"
    />
    <path
      d="M118.98 16.727c.614 7.977-3.531 14.721-10.103 15.11-6.572.39-12.284-6.485-12.898-14.364-.614-7.879 1.505-14.396 10.349-14.396 8.844 0 12.314 5.674 12.652 13.65Z"
      fill="#F1BE96"
    />
    <path
      d="M103.073 15.625c-1.628-.292-.338 5.447-1.351 6.226-1.014.778-1.474-3.73-3.071-3.73-2.457 0-1.935 6.486-2.733-.453-.86-8.074 1.566-14.591 10.41-14.591a10.782 10.782 0 0 1 6.645 1.491c2.016 1.207 3.632 3.041 4.625 5.253.261.572.392 1.2.383 1.835a4.27 4.27 0 0 1-.435 1.822 4.028 4.028 0 0 1-1.162 1.423 3.761 3.761 0 0 1-1.642.724 30.596 30.596 0 0 1-11.669 0Z"
      fill="#28211E"
    />
    <path
      opacity=".6"
      d="m87.38 177.423 24.906-5.188-42.256-22.178-24.874 5.22 42.224 22.146Z"
      fill="url(#servicepoint_paint0_linear)"
    />
    <path d="m112.255 101.809 74.224-14.04-42.256-22.145-74.193 14.04 42.225 22.145Z" fill="#FDDE84" />
    <path d="M112.255 101.809v70.426L70.03 150.089V79.663l42.225 22.146Z" fill="#C39000" />
    <path d="M112.255 101.809v70.426l74.224-14.039V87.769l-74.224 14.04Z" fill="#FCCE09" />
    <path d="m111.549 100.415 77.54-14.656-44.129-23.183-77.54 14.688 44.129 23.151Z" fill="#996A0D" />
    <path d="M111.549 100.415v4.442l-44.13-23.15v-4.443l44.13 23.151Z" fill="#634509" />
    <path d="M111.549 100.415v4.442l77.54-14.656V85.76l-77.54 14.656Z" fill="#BC9361" />
    <path
      opacity=".4"
      d="m105.284 99.086 12.406-2.594-14.648-7.75-12.406 2.594 14.648 7.75Z"
      fill="url(#servicepoint_paint1_linear)"
    />
    <path d="m117.69 86.148 14.341-2.594-14.648-7.75-14.341 2.595 14.648 7.75Z" fill="#FDDE84" />
    <path opacity=".4" d="m111.856 83.1 14.341-2.594-3.501-1.848-14.372 2.594 3.532 1.848Z" fill="#AA7B33" />
    <path d="M117.69 86.148V96.46l-14.648-7.75V78.4l14.648 7.75Z" fill="#C39000" />
    <path opacity=".4" d="M111.856 83.1v4.8l-3.532-1.914v-4.734l3.532 1.848Z" fill="#AA7B33" />
    <path d="M117.69 86.148V96.46l14.341-2.626V83.554l-14.341 2.594Z" fill="#FCCE09" />
    <path d="M119.656 88.386v6.355l10.379-1.88v-6.356l-10.379 1.88Z" fill="#fff" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m125.644 92.374 1.812-.325v-3.793l-1.812.324v3.794ZM120.638 93.444l1.536-.292v-3.923l-1.536.291v3.924ZM123.894 92.698h.767v-3.923h-.767v3.923ZM129.053 87.964h-.768v3.794h.768v-3.794ZM123.034 92.86h.307v-3.858h-.307v3.858Z"
      fill="#000"
    />
    <path
      opacity=".4"
      d="m136.761 85.435 8.936-1.88-15.17-7.945-8.937 1.849 15.171 7.976Z"
      fill="url(#servicepoint_paint2_linear)"
    />
    <path d="m145.697 58.263 26.686-5.026-15.17-7.976-26.686 5.058 15.17 7.944Z" fill="#FDDE84" />
    <path opacity=".4" d="m139.187 54.826 26.655-5.026-2.518-1.33-26.717 5.027 2.58 1.33Z" fill="#AA7B33" />
    <path d="M145.697 58.263v25.291l-15.17-7.944V50.32l15.17 7.943Z" fill="#C39000" />
    <path opacity=".4" d="M139.187 54.826v5.48l-2.58-1.394v-5.415l2.58 1.33Z" fill="#AA7B33" />
    <path d="M145.697 58.263v25.291l26.686-5.025V53.237l-26.686 5.026Z" fill="#FCCE09" />
    <path d="m113.606 21.526.983 3.826-1.597-.26" fill="#DEA07B" />
    <path
      d="m122.481 134.882 7.524-1.524-.4.681-7.124 1.427v-.584ZM122.481 133.812l8.291-1.653-.399.648-7.892 1.589v-.584ZM122.481 135.952l6.756-1.361-.399.648-6.357 1.265v-.552ZM178.157 124.312l-7.493 1.491.399-.648 7.094-1.427v.584ZM178.156 125.349l-8.26 1.654.399-.648 7.861-1.557v.551ZM171.83 123.923l6.326-1.265v.584l-6.725 1.329.399-.648ZM129.79 135.045l3.562-5.675 4.422-.875c.491 0 .491 0 .246.486l-.891 1.427c0 .194-.338.551.399.421l6.019-1.199a8.182 8.182 0 0 1-2.138 2.372 7.723 7.723 0 0 1-2.836 1.324l-8.722 1.751-.061-.032ZM150.242 128.268l-1.935 3.08-5.128 1.005 1.935-3.08 5.128-1.005ZM157.612 126.776l-1.935 3.081-5.097 1.037 1.934-3.08 5.098-1.038ZM159.301 126.452l-.553.875c-.644 1.006 0 1.946 2.027 1.524l8.2-1.653 1.934-3.081-11.608 2.335Z"
      fill="#D40511"
    />
    <path
      d="m132.277 126.517-1.781 2.821 9.704-1.946c.492 0 .492 0 .246.487l-.891 1.426c0 .195-.338.551.399.422l3.962-.778 1.167-1.881c.737-1.167 0-3.242-2.549-2.594l-10.257 2.043ZM158.073 126.095l-12.499 2.497 3.409-5.415 5.098-1.038-1.966 3.113 2.303-.454 1.935-3.112 5.129-1.038-3.409 5.447ZM168.545 119.383l-3.501 5.286-5.313 1.199 3.409-5.415 5.405-1.07Z"
      fill="#D40511"
    />
    <path d="m114.466 46.785.614 5.934 3.317.616 2.456-1.751-.614-5.902-5.773 1.103Z" fill="#C9C9C9" />
    <path
      d="m120.331 46.752-.092-1.07-5.773 1.103.092 1.07M110.781 40.916a.803.803 0 0 1-.169.48.73.73 0 0 1-.415.266.436.436 0 0 1-.422-.096.511.511 0 0 1-.161-.423.802.802 0 0 1 .169-.48.728.728 0 0 1 .414-.266.44.44 0 0 1 .422.096.482.482 0 0 1 .131.19.512.512 0 0 1 .031.233ZM111.027 43.77a.81.81 0 0 1-.169.48.731.731 0 0 1-.415.265.435.435 0 0 1-.422-.096.492.492 0 0 1-.161-.423.801.801 0 0 1 .168-.48.732.732 0 0 1 .415-.265.435.435 0 0 1 .422.096.482.482 0 0 1 .131.19.525.525 0 0 1 .031.232ZM111.303 46.752a.803.803 0 0 1-.169.48.73.73 0 0 1-.415.266.435.435 0 0 1-.422-.096.511.511 0 0 1-.161-.423.802.802 0 0 1 .169-.48.732.732 0 0 1 .414-.265.44.44 0 0 1 .422.096.48.48 0 0 1 .131.19.511.511 0 0 1 .031.232Z"
      fill="#8E8E8E"
    />
    <path d="M157.182 70.747v7.133l11.67-2.108v-7.165l-11.67 2.14Z" fill="#fff" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m163.908 75.221 2.057-.389v-4.247l-2.057.389v4.247ZM158.288 76.259l1.719-.325v-4.247l-1.719.324v4.248ZM161.973 75.578h.86v-4.41h-.86v4.41ZM167.746 70.26h-.86v4.248h.86V70.26ZM160.959 75.772h.338V71.46h-.338v4.312Z"
      fill="#000"
    />
    <defs>
      <linearGradient
        id="servicepoint_paint0_linear"
        x1="71.846"
        y1="168.046"
        x2="79.182"
        y2="153.219"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".25" stopOpacity="0" />
        <stop offset=".599" stopOpacity=".3" />
        <stop offset="1" stopOpacity=".8" />
      </linearGradient>
      <linearGradient
        id="servicepoint_paint1_linear"
        x1="101.392"
        y1="95.542"
        x2="104.056"
        y2="89.801"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".25" stopOpacity="0" />
        <stop offset=".599" stopOpacity=".3" />
        <stop offset="1" stopOpacity=".8" />
      </linearGradient>
      <linearGradient
        id="servicepoint_paint2_linear"
        x1="1287.15"
        y1="319.851"
        x2="1291.3"
        y2="299.81"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0" />
        <stop offset=".21" stopOpacity="0" />
        <stop offset="1" />
      </linearGradient>
    </defs>
  </SvgIcon>
)
